import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=bac83178&scoped=true&"
import script from "./TableCard.vue?vue&type=script&lang=js&"
export * from "./TableCard.vue?vue&type=script&lang=js&"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=bac83178&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac83178",
  null
  
)

export default component.exports